import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { useAppContext } from "../../api/AppContext";

const ProductContext = createContext();
const SOCKET_URL = "https://cardapio.olympicbarbacena.com.br";

export const ProductProvider = ({ children }) => {
  const { isAuthenticated } = useAppContext();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [onlineUsers, setOnlineUsers] = useState(0);
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({ cover: "", logo: "" });
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setLoading(false);
      return;
    }
    if (fetched) return;

    const fetchData = async () => {
      try {
        const [productsRes, categoriesRes, settingsRes] = await Promise.all([
          axios.get(`${SOCKET_URL}/api/produtos`),
          axios.get(`${SOCKET_URL}/api/categories`),
          axios.get(`${SOCKET_URL}/api/settings`)
        ]);
        setProducts(productsRes.data);
        setCategories(categoriesRes.data);
        setSettings(settingsRes.data);
        setFetched(true);
      } catch (error) {
        console.error("Erro ao buscar dados do cardapio:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [isAuthenticated, fetched]);

  return (
    <ProductContext.Provider
      value={{
        products,
        categories,        
        onlineUsers,
        setProducts,
        setCategories,        
        loading,
        settings
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export default ProductContext;
